const SDK_VERSION = "10.75.2" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
